import { RichText } from 'components/Text/RichText';
import { useAbExperimentBucket } from 'hooks/abExperiment/useAbExperimentBucket';
import { colors } from 'theme/theme';

import { ListingRichTextHolder } from './ListingRichText.styled';

type Props = {
  content: string;
};

export function ListingRichText({ content }: Props) {
  const [bucket] = useAbExperimentBucket('RICH_TEXT_EDITOR_2024_07');

  if (bucket === 'QUILL') {
    return (
      <RichText
        styleAs="body"
        color={colors.darkContentGrey}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  return (
    <ListingRichTextHolder dangerouslySetInnerHTML={{ __html: content }} />
  );
}
